import React from 'react'
import styles from './Footer.module.css'
import { HoverState } from '../../assets/utils/cursorTypes';
import IconComponent from '../IconComponent/IconComponent';
import { FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { smoothScrollTo } from '../../assets/utils/smoothScroll';

export type FooterProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    setNavOpened: React.Dispatch<React.SetStateAction<boolean>>;
    navbarRef: React.RefObject<HTMLDivElement | null>;
}

const Footer = (props: FooterProps) => {

    const navigate = useNavigate();

        const handleScroll = (target: string) => {
            const targetElement = document.getElementById(target.toString());
            if (targetElement) {
                props.setNavOpened(false);
                const navbarHeight = props.navbarRef.current?.offsetHeight || 0;
                const offsetTop = targetElement.offsetTop - navbarHeight;
                smoothScrollTo(offsetTop, 800);
            }
        };

    const navLinkScroll = (target: string) => {
        if(window.location.pathname === '/'){
            handleScroll(target);
        }else{
            navigate(`/#${target}`);
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.space}></div>
            <div className={styles.items}>
                <div className={styles.item_content}>
                    <div className={styles.menuLogo}
                        onMouseEnter={() => props.setHoverElement('pointer')}
                        onMouseLeave={() => props.setHoverElement('normal')}
                        onClick={() => navigate("")}>
                    </div>
                    <span className={styles.jv_2025}>@2025 Jorge Vieira</span>
                </div>
                <div className={styles.itemGroup}>
                    <div className={styles.item}>
                        <span className={styles.item_title}>Explore</span>
                        <div className={styles.item_content}>
                            <span
                                onClick={() => navLinkScroll('home')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >Home</span>
                            <span
                                onClick={() => navLinkScroll('about')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >About</span>
                            <span
                                onClick={() => navLinkScroll('experience')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >Experience</span>
                            <span
                                onClick={() => navLinkScroll('projects')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >Projects</span>
                            <span
                                onClick={() => navLinkScroll('contact')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >Contact</span>
                        </div>
                    </div>
                    <div className={styles.item}>
                        <span className={styles.item_title}>Get in Touch</span>
                        <span className={styles.item_desc}>Questions or just want to exchange information?</span>
                        <div className={styles.item_icons}>
                            <a 
                                href="https://www.instagram.com/jorgev018/"
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <IconComponent icon={FaInstagram} size={25} />
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/jorgevieira18/"
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <IconComponent icon={FaLinkedin} size={25} />
                            </a>
                            <a 
                                href="https://github.com/JorgeFMVieira"
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <IconComponent icon={FaGithub} size={25} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
